import { CreateDtoInterface } from '../base/createDto.interface'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class BaseCreateDto<T> implements CreateDtoInterface {
  public constructor (partial?: Partial<T>) {
    Object.assign(this, partial)
  }
}
